export interface ShipmentActivityOpenContext {
  tracking: string;
  record: any;
}

export interface ShipmentActivityController {
  open: (context: ShipmentActivityOpenContext) => void;
  updateRecord: (record: any) => void;
  reset: () => void;
}

declare global {
  interface Window {
    ShipmentActivityController?: ShipmentActivityController;
    tracker?: any;
  }
}

export function registerShipmentActivityController(controller: ShipmentActivityController): void {
  window.ShipmentActivityController = controller;
}
